import {type NodeData, type NodeDataMap, type NodeId} from '../../../values/nodes/NodeData'
import {type LocationIdType} from '../locations/state'

export type LocationNodeArrayMapType = Map<LocationIdType, Array<NodeData>>
export interface LatestNodeDetails {
    id: NodeId
    timeStamp: string
}
export interface NodesReduxState {
    isFetchingNodes: boolean
    nodes: NodeDataMap
    nodesForLocations: LocationNodeArrayMapType
    nodesForAgentForLocations: LocationNodeArrayMapType
    latestNodeDetails: LatestNodeDetails | undefined
}

export const DEFAULT_NODES_STATE: NodesReduxState = {
    isFetchingNodes: true,
    nodes: new Map<NodeId, NodeData>(),
    nodesForLocations: new Map<LocationIdType, Array<NodeData>>(),
    nodesForAgentForLocations: new Map<LocationIdType, Array<NodeData>>(),
    latestNodeDetails: undefined,
}
